(function () {
  const dropdown = ".event-actions-btn";
  const secondLevelDropdowns = ".dropdown-menu.second-level";

  const outingsEventActionsApp = function () {
    const bindOnHideDropDown = () => {
      $(dropdown)
        .parent()
        .on("hide.bs.dropdown", function () {
          $(this).find(secondLevelDropdowns).removeClass("d-table").addClass("d-none");
        });
    };

    const bindDeleteEvent = () => {
      $(document).on("click", ".delete-event-link", function (e) {
        e.preventDefault();
        that = this;
        window.swalConfirm
          .fire({
            title: "Are you sure?",
            cancelButtonText: "No",
            confirmButtonText: "Yes",
          })
          .then((result) => {
            if (!result.isConfirmed) return;

            const authenticity_token = $("meta[name=csrf-token]").attr("content");
            $.ajax({
              method: "delete",
              url: $(that).attr("href"),
              data: { authenticity_token },
            });
          });
      });
    };

    const bindCloneEvent = () => {
      $(document).on("click", ".clone-event-link", function (e) {
        e.preventDefault();
        that = this;
        window.swalConfirm
          .fire({
            title: "Clone this event and all related data?",
            cancelButtonText: "No",
            confirmButtonText: "Yes",
          })
          .then((result) => {
            if (!result.isConfirmed) return;

            $(".generic-loader").removeClass("d-none");
            const authenticity_token = $("meta[name=csrf-token]").attr("content");
            $.ajax({
              method: "post",
              url: $(that).attr("href"),
              data: { authenticity_token },
              success: function () {
                window.location.reload();
              },
              error: function () {
                $(".generic-loader").addClass("d-none");
              },
            });
          });
      });
    };

    const init = () => {
      bindOnHideDropDown();
      bindDeleteEvent();
      bindCloneEvent();
    };

    $(document).on("turbolinks:load", init);
  };

  if (typeof window !== "undefined") {
    window.outingsEventActionsApp = outingsEventActionsApp();
  }

  return outingsEventActionsApp;
})();
